import React from "react";

const FIN = {
  gold: ["#F4DE8E", "#C9A227", "#8A6D14"],
  silver: ["#F2F2F2", "#C2C6CC", "#8A8E94"],
  bronze: ["#EBB980", "#C67B3E", "#7E4A22"],
  antique: ["#D8C89A", "#A98B4E", "#6E5A2E"],
};

const starPoints = (cx, cy, outer, inner, n = 5) => {
  let pts = [];
  for (let i = 0; i < n * 2; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = (Math.PI / n) * i - Math.PI / 2;
    pts.push(`${cx + r * Math.cos(a)},${cy + r * Math.sin(a)}`);
  }
  return pts.join(" ");
};

const MedalPreview = ({ design, svgId = "design-svg" }) => {
  const { shape, finish, ribbon, text, logo } = design;
  const c = FIN[finish] || FIN.gold;
  const cx = 150, cy = 250, R = 92;

  const disc =
    shape === "star" ? (
      <polygon points={starPoints(cx, cy, R, R * 0.45)} fill="url(#medalGrad)" stroke={c[2]} strokeWidth="3" />
    ) : shape === "shield" ? (
      <path d={`M${cx - R},${cy - R} L${cx + R},${cy - R} L${cx + R},${cy + R * 0.2} Q${cx + R},${cy + R} ${cx},${cy + R} Q${cx - R},${cy + R} ${cx - R},${cy + R * 0.2} Z`} fill="url(#medalGrad)" stroke={c[2]} strokeWidth="3" />
    ) : (
      <circle cx={cx} cy={cy} r={R} fill="url(#medalGrad)" stroke={c[2]} strokeWidth="3" />
    );

  return (
    <svg id={svgId} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400" width="300" height="400" className="w-full h-auto">
      <rect width="300" height="400" fill="#f6f7f9" />
      <defs>
        <radialGradient id="medalGrad" cx="38%" cy="32%" r="75%">
          <stop offset="0%" stopColor={c[0]} />
          <stop offset="55%" stopColor={c[1]} />
          <stop offset="100%" stopColor={c[2]} />
        </radialGradient>
        <clipPath id="medalClip">
          {shape === "circle" ? <circle cx={cx} cy={cy} r={R} /> : shape === "star" ? <polygon points={starPoints(cx, cy, R, R * 0.45)} /> : <path d={`M${cx - R},${cy - R} L${cx + R},${cy - R} L${cx + R},${cy + R * 0.2} Q${cx + R},${cy + R} ${cx},${cy + R} Q${cx - R},${cy + R} ${cx - R},${cy + R * 0.2} Z`} />}
        </clipPath>
      </defs>

      {/* Ribbon */}
      <polygon points="110,20 150,150 100,150 80,20" fill={ribbon} />
      <polygon points="190,20 220,20 200,150 150,150" fill={ribbon} opacity="0.85" />

      {disc}
      {/* inner ring */}
      {shape === "circle" && <circle cx={cx} cy={cy} r={R - 14} fill="none" stroke={c[2]} strokeWidth="2" opacity="0.5" />}

      {logo ? (
        <g clipPath="url(#medalClip)"><image href={logo} x={cx - 55} y={cy - 62} width="110" height="90" preserveAspectRatio="xMidYMid meet" /></g>
      ) : (
        <text x={cx} y={cy - 6} textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="800" fontSize="30" fill={c[2]}>LOGO</text>
      )}
      {text ? (
        <text x={cx} y={cy + 58} textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="700" fontSize="18" fill={c[2]} style={{ textTransform: "uppercase" }}>{text}</text>
      ) : null}
    </svg>
  );
};

export default MedalPreview;
